import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconMap = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M30.64 1.924c-8.74.452-16.623 5.637-20.579 13.537-1.193 2.382-2.05 5.211-2.374 7.835-.41 3.32-.129 7.447.76 11.168.61 2.559 1.465 4.885 2.752 7.488 1.96 3.964 4.415 7.357 7.84 10.839 2.044 2.078 3.643 3.477 5.94 5.2 1.74 1.306 4.279 2.972 5.346 3.51.412.207 1.19.387 1.675.387.484 0 1.263-.18 1.675-.388 1.1-.554 3.602-2.199 5.397-3.548 2.275-1.71 3.862-3.102 5.889-5.161 3.425-3.482 5.88-6.875 7.84-10.839 2.09-4.225 3.18-8.105 3.592-12.768.103-1.175.106-4.264.004-5.184-.333-3.015-1.054-5.594-2.284-8.17-2.396-5.018-6.559-9.191-11.519-11.546a24.4 24.4 0 0 0-7.426-2.2c-.721-.093-2.969-.238-3.392-.218zm-.304 4.035a21.4 21.4 0 0 0-5.568 1.25c-.855.314-2.915 1.339-3.704 1.842-4.763 3.04-8.106 7.91-9.164 13.349-.445 2.292-.498 4.973-.151 7.776 1.161 9.402 6.773 18.084 16.155 24.992a51 51 0 0 0 3.441 2.293l.657.39.815-.492c4.764-2.87 9.407-6.997 12.709-11.298 4.713-6.139 7.12-13.14 6.933-20.165-.041-1.557-.127-2.349-.395-3.647a20.6 20.6 0 0 0-9.138-13.203c-.795-.503-2.862-1.53-3.694-1.837-2.895-1.063-6.018-1.502-8.896-1.25m.352 7.233c-5.15.49-9.623 4.07-11.26 9.016a13.2 13.2 0 0 0 3.26 13.602c2.03 2.014 4.64 3.299 7.533 3.71.855.122 2.702.122 3.558 0 4.663-.663 8.578-3.643 10.404-7.92a13.2 13.2 0 0 0 .387-9.392c-1.959-5.886-7.685-9.605-13.882-9.016m.32 4c-1.23.187-2.25.49-3.13.933a9.31 9.31 0 0 0-5.033 7.032c-.1.698-.045 2.41.099 3.067.395 1.816 1.236 3.367 2.531 4.667 1.598 1.604 3.59 2.521 5.843 2.69a9.13 9.13 0 0 0 7.207-2.69q1.941-1.948 2.531-4.667c.143-.658.197-2.288.1-3.027-.355-2.71-1.91-5.131-4.265-6.648-.777-.5-2.002-.99-3.018-1.207-.608-.13-2.385-.223-2.865-.15" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconMap.displayName = 'IconMap';